import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import EnglishPage from "../pages/en/page";
import CaseLargeSizeClothing from "../pages/case-large-size-clothing/page";
import CaseClothingForWomen from "../pages/case-clothing-for-women/page";
import CaseViewsonicOzon from "../pages/case-viewsonic-ozon/page";
import CaseHealthSnack from "../pages/case-health-snack/page";
import CaseHotel from "../pages/case-hotel/page";
import CaseCosmetic from "../pages/case-cosmetic/page";
import CaseBaitForFish from "../pages/case-bait-for-fish/page";
import CasesPage from "../pages/cases/page";
import LandingPage from "../pages/landing-page/page";
import LandingPageSupport from "../pages/landing-page-support/page";
import AuditLandingPage from "../pages/audit-landing-page/page";
import AnalyticsPage from "../pages/analytics/page";
import SEOArticlePage from "../pages/seo-article/page";
import SMMStrategyPage from "../pages/smm-strategy/page";
import AIAvatarPage from "../pages/ai-avatar/page";
import ContextAdsPage from "../pages/context-ads/page";
import OfertaPage from "../pages/oferta/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/en",
    element: <EnglishPage />,
  },
  {
    path: "/case",
    element: <CasesPage />,
  },
  {
    path: "/landing-page",
    element: <LandingPage />,
  },
  {
    path: "/landing-page-support",
    element: <LandingPageSupport />,
  },
  {
    path: "/audit-landing-page",
    element: <AuditLandingPage />,
  },
  {
    path: "/analytics",
    element: <AnalyticsPage />,
  },
  {
    path: "/SEO-article",
    element: <SEOArticlePage />,
  },
  {
    path: "/SMM-strategy",
    element: <SMMStrategyPage />,
  },
  {
    path: "/AI-avatar",
    element: <AIAvatarPage />,
  },
  {
    path: "/context-ads",
    element: <ContextAdsPage />,
  },
  {
    path: "/case/large-size-clothing",
    element: <CaseLargeSizeClothing />,
  },
  {
    path: "/case/clothing-for-women",
    element: <CaseClothingForWomen />,
  },
  {
    path: "/case/viewsonic-Ozon",
    element: <CaseViewsonicOzon />,
  },
  {
    path: "/case/health-snack",
    element: <CaseHealthSnack />,
  },
  {
    path: "/case/hotel",
    element: <CaseHotel />,
  },
  {
    path: "/case/cosmetic",
    element: <CaseCosmetic />,
  },
  {
    path: "/case/bait-for-fish",
    element: <CaseBaitForFish />,
  },
  {
    path: "/oferta",
    element: <OfertaPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;